'use strict';

var Networks = /* @__PURE__ */ ((Networks2) => {
  Networks2["PUBLIC"] = "Public Global Stellar Network ; September 2015";
  Networks2["TESTNET"] = "Test SDF Network ; September 2015";
  Networks2["FUTURENET"] = "Test SDF Future Network ; October 2022";
  Networks2["SANDBOX"] = "Local Sandbox Stellar Network ; September 2022";
  Networks2["STANDALONE"] = "Standalone Network ; February 2017";
  return Networks2;
})(Networks || {});

exports.Networks = Networks;
//# sourceMappingURL=network.js.map
